// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import DashboardV2 from "./components/DashboardV2";
import ProtectedRoute from "./components/ProtectedRoute";
import Reports from "./components/Reports";
import RolesEditor from "./components/RolesEditor"; // ← add this

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardV2 />
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />

        {/* Admin-only page (also checks admin inside RolesEditor) */}
        <Route
          path="/admin/roles"
          element={
            <ProtectedRoute>
              <RolesEditor />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
